var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63988 18.035L9.39488 19.79L18.7099 10.475L16.9549 8.71999L7.63988 18.035ZM16.1449 7.90999L14.3899 6.15499L5.07488 15.47L6.96488 17.36L16.1449 7.90999ZM18.9799 1.56499L23.4349 6.01999C24.2449 6.82999 24.1099 8.04499 23.4349 8.71999L10.0699 22.085L0.754883 23.975L2.64488 14.66C11.0149 6.15499 15.4699 1.69999 16.0099 1.29499C16.8199 0.754987 18.1699 0.754987 18.9799 1.56499Z",
    fill: "#8BAEC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4ca80ac9b90b99bf0f44ed00e806fe23.svg";
export { ForwardRef as ReactComponent };